import {
  Required,
  DataValidator,
  transformKeys,
  IsBoolean,
} from "@/utils/type-vaildator";
import api from "./api";

interface ActorRenameResponse {
  is_duplicate: boolean,
}

class ActorRenameData {
  @Required("isDuplicate cannot be empty")
  @IsBoolean("isDuplicate must be a boolean")
  isDuplicate: boolean;
}

const transformAndValidateData = (
  response: ActorRenameResponse
): ActorRenameData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, ActorRenameData);
  } catch (error) {
    console.error("Actor rename list data validation failed:", error.message);
    throw error;
  }
};

/** 演员重命名 */
export const actorRename = async ({ id, name, userId }: { id: string, name: string, userId?: string }) => {
  const res = await api.post<ActorRenameResponse>('/users/rename-actor-template', {
    actor_id: id,
    actor_name: name,
    user_id: userId,
  });
  const data = transformAndValidateData(res.data);  
  return data;
}